import {
  AppStateResidentsStatus,
  BedStatusValue,
  EMPTY_ACTIVITY_STATUS,
  EMPTY_BED_STATUS,
  EMPTY_LOCATION_STATUS,
  ResidentBedStatus,
  ResidentStatus,
  ResidentStatusesSocket,
  ResidentStatusMap,
  ResidentStatusNames,
} from ".";
import {
  IBatchDisconectAndChangeResidentsSuccess,
  IDeleteManyResidentsSuccess,
  IGetResidentsStuffSuccess,
  ResidentActionTypes,
  RESIDENTS,
} from "../residents/types";
const initialState: AppStateResidentsStatus = {
  bedStatuses: {},
  activityStatuses: {},
  locationStatuses: {},
  // postureStatuses: {},
  isLoading: false,
};

const convertBed = (bedSt: any) => {
  const newBed: ResidentBedStatus = bedSt;
  Object.keys(newBed).map((key) => {
    const oldValue = newBed[key];
    if (typeof oldValue === "string" || oldValue instanceof String) {
      const newValue = oldValue.substr(0, 1).toLowerCase() + oldValue.substr(1);
      newBed[key] = newValue;
    }
    return null;
  });
  return newBed;
};

const deleteData = (statuses: ResidentStatusMap, ids: string[]) => {
  const statusesCopy = { ...statuses };
  let changed = false;
  ids.map((id) => {
    if (statuses[id]) {
      delete statusesCopy[id];
      changed = true;
    }
    return null;
  });
  return changed ? statusesCopy : statuses;
};

const changeToInit = (
  statuses: ResidentStatusMap,
  ids: string[],
  name: ResidentStatusNames
) => {
  const statusesCopy = { ...statuses };
  ids.map((id) => {
    if (statuses[id]) {
      statusesCopy[id] =
        name === ResidentStatusNames.ACTIVE
          ? EMPTY_ACTIVITY_STATUS
          : name === ResidentStatusNames.BED
          ? EMPTY_BED_STATUS
          : EMPTY_LOCATION_STATUS;
    }
    return null;
  });
  return statusesCopy;
};

const reducer = (
  state = initialState,
  action: ResidentActionTypes
): AppStateResidentsStatus => {
  switch (action.type) {
    case RESIDENTS.GET_RESIDENTS_RULES_ALERTS_STATUSES_REQUEST: {
      return { ...state, isLoading: true };
    }
    case RESIDENTS.GET_RESIDENTS_RULES_ALERTS_STATUSES_FAILURE: {
      return { ...state, isLoading: false };
    }
    case RESIDENTS.GET_RESIDENTS_RULES_ALERTS_STATUSES_SUCCESS: {
      const items = (action as IGetResidentsStuffSuccess).payload;
      const bedStatuses = {};
      const activityStatuses = {};
      const locationStatuses = {};
      const postureStatuses = {};
      if (Array.isArray(items) && items.length > 0) {
        items.map((el: any) => {
          const { self, statuses } = el;
          Object.keys(statuses).map((statusFieldKey: string) => {
            const statusPro: any = statuses[statusFieldKey];
            const status: ResidentStatus =
              statusPro === null
                ? { id: statusFieldKey }
                : { ...statusPro, id: statusFieldKey };
            switch (statusFieldKey) {
              case ResidentStatusNames.BED:
                bedStatuses[self.id] = convertBed(status);
                break;
              case ResidentStatusNames.ACTIVE:
                activityStatuses[self.id] = status;
                break;
              case ResidentStatusNames.LOCATION:
                locationStatuses[self.id] = status;
                break;
              case ResidentStatusNames.POSTURE:
                postureStatuses[self.id] = status;
                break;
            }
            return null;
          });
          return null;
        });
        return {
          ...state,
          bedStatuses,
          activityStatuses,
          locationStatuses,
          isLoading: false,
        };
      }

      return { ...state, isLoading: false };
    }
    case RESIDENTS.ADD_RESIDENT_BY_SOCKET: {
      const newResident = action.payload as any;

      const { statuses, self } = newResident;
      if (!statuses) return state;
      const bedStatuses = {};
      const activityStatuses = {};
      const locationStatuses = {};
      const postureStatuses = {};
      Object.keys(statuses).map((statusFieldKey: string) => {
        const statusPro: any = statuses[statusFieldKey];
        const status: ResidentStatus =
          statusPro === null
            ? { id: statusFieldKey }
            : { ...statusPro, id: statusFieldKey };
        switch (statusFieldKey) {
          case ResidentStatusNames.BED:
            bedStatuses[self.id] = convertBed(status);
            break;
          case ResidentStatusNames.ACTIVE:
            activityStatuses[self.id] = status;
            break;
          case ResidentStatusNames.LOCATION:
            locationStatuses[self.id] = status;
            break;
          case ResidentStatusNames.POSTURE:
            postureStatuses[self.id] = status;
            break;
        }
        return null;
      });
      return {
        ...state,
        bedStatuses: { ...state.bedStatuses, ...bedStatuses },
        activityStatuses: { ...state.activityStatuses, ...activityStatuses },
        locationStatuses: { ...state.locationStatuses, ...locationStatuses },
        // postureStatuses: { ...state.postureStatuses, ...postureStatuses },
      };
    }
    case RESIDENTS.UPDATE_STATUSES_BY_SOCKET: {
      const data = action.payload as ResidentStatusesSocket;
      if (data.bedStatus) {
        const wasSt: ResidentBedStatus = state.bedStatuses[
          data?.bedStatus?.residentId
        ] as ResidentBedStatus;
        return {
          ...state,
          bedStatuses: {
            ...state.bedStatuses,
            [data?.bedStatus?.residentId]: {
              ...wasSt,
              value:
                data.bedStatus.status.toLowerCase() ===
                BedStatusValue.IN_BED.toLowerCase()
                  ? BedStatusValue.IN_BED
                  : data.bedStatus.status.toLowerCase() ===
                    BedStatusValue.OUT_OF_BED.toLowerCase()
                  ? BedStatusValue.OUT_OF_BED
                  : BedStatusValue.INIT,
            },
          },
        };
      }
      if (data.activityStatus) {
        const wasSt = state.activityStatuses[data?.activityStatus?.residentId];
        return {
          ...state,
          activityStatuses: {
            ...state.activityStatuses,
            [data?.activityStatus?.residentId]: {
              ...wasSt,
              value: data.activityStatus.value,
            },
          },
        };
      }
      return state;
    }

    case RESIDENTS.DELETE_MANY_RESIDENTS_SUCCESS: {
      const data = (action as IDeleteManyResidentsSuccess).payload;
      return {
        ...state,
        activityStatuses: deleteData(state.activityStatuses, data),
        bedStatuses: deleteData(state.bedStatuses, data),
        locationStatuses: deleteData(state.locationStatuses, data),
        // postureStatuses: deleteData(state.postureStatuses, data),
      };
    }
    case RESIDENTS.BATCH_DISCONNECT_AND_CHANGE_SUCCESS: {
      const data = (action as IBatchDisconectAndChangeResidentsSuccess).payload;

      const ids = data.map((el) => el.id);
      return {
        ...state,
        activityStatuses: changeToInit(
          state.activityStatuses,
          ids,
          ResidentStatusNames.ACTIVE
        ),
        bedStatuses: changeToInit(
          state.bedStatuses,
          ids,
          ResidentStatusNames.BED
        ),
        locationStatuses: changeToInit(
          state.locationStatuses,
          ids,
          ResidentStatusNames.LOCATION
        ),
        // postureStatuses: changeToInit(state.postureStatuses, ids, ResidentStatusNames.POSTURE),
      };
    }
    case RESIDENTS.DELETE_RESIDENT_BY_SOCKET: {
      const data = action.payload;
      return {
        ...state,
        activityStatuses: deleteData(state.activityStatuses, [data.id]),
        bedStatuses: deleteData(state.bedStatuses, [data.id]),
        locationStatuses: deleteData(state.locationStatuses, [data.id]),
        // postureStatuses: deleteData(state.postureStatuses, [data.id]),
      };
    }

    default:
      return state;
  }
};
export default reducer;
